import React, { useState, useEffect } from 'react';
import {
  formatDateMonth,
  KTSVG,
  LoadingGrid,
  SimpleAlert,
} from '../../../../../_mexablock/helpers';
import { CreateModal } from '../_modals/CreateModal';
import { UpdateModal } from '../_modals/UpdateModal';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import 'flatpickr/dist/flatpickr.min.css';
import { MenuComponent } from '../../../../../_mexablock/assets/ts/components';
import { useGetAll } from '../hooks/ZonasHook';
import { ConfirmModal } from '../../../../../_mexablock/helpers/components/ConfirmationModal';
import { deleteZona } from '../../../../service/catalog/zonas';

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [idUpd, setIdUpd] = useState<number>(0);
  const [visivilityModal, setVisivilityModal] = useState<boolean>(false);
  const [visivilityUpdModal, setVisivilityUpdModal] = useState<boolean>(false);
  const [visivilityModalConfimation, setVisivilityModalConfimation] =
    useState<boolean>(false);
  const [initFilterValues] = useState({
    init_date: '',
    end_date: '',
  });
  const [reloadGrid, setReloadGrid] = useState<number>(Math.random() * 40);
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);

  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 1000);

  const columns: any = [
    {
      id: 'createdAt',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => formatDateMonth(row.createdAt),
      sortable: true,
    },

    {
      id: 'Zona',
      name: <div className="fw-bolder text-muted me-5">Zona</div>,
      selector: (row: any) => row.name,
      sortable: true,
    },

    {
      id: 'Responsable',
      name: <div className="fw-bolder text-muted me-5">Responsable</div>,
      selector: (row: any) => row.user?.first_name,
      cell: (row: any) => {
        if (row.hasResponsible) {
          const c = row.user;
          return (
            <div>
              {c
                ? `${c.first_name || ''} ${c.father_last_name || ''} ${
                    c.mother_last_name || ''
                  }`.trim()
                : 'Sin asignar'}
            </div>
          );
        }
        return 'Sin responsable';
      },
      sortable: true,
    },

    {
      id: 'email',
      name: <div className="fw-bolder text-muted me-5">Correo</div>,
      selector: (row: any) => row.user?.email,
      sortable: true,
      width: '180px',
    },

    {
      id: 'periodic_recharge',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => row.active,
      cell: (row: any) => (
        <>
          {row.active ? (
            <span className="badge badge-light-success">Activo</span>
          ) : (
            <span className="badge badge-light-danger">Inactivo</span>
          )}
        </>
      ),
      sortable: true,
    },

    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted me-5"></div>,
      cell: (row: any) => dropdownRender(row),
      sortable: false,
    },
  ];

  const dropdownRender = (row: any) => {
    const isDisabled = row.status_id === 15;
    return (
      <>
        <div className="d-flex justify-content-end flex-shrink-0">
          <a
            data-kt-menu="true"
            className="btn btn-light btn-active-light-primary btn-sm"
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
          >
            Acciones
            <span className="svg-icon svg-icon-5 m-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mh-50px"
              >
                <path
                  d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </a>

          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
            data-kt-menu="true"
          >
            <div className="menu-item px-3">
              <a
                className="menu-link px-3"
                href="#/"
                onClick={() => {
                  setIdUpd(row.id);
                  setVisivilityUpdModal(true);
                }}
              >
                Editar
              </a>
            </div>
            <div className="menu-item px-3">
              <a
                className="menu-link px-3"
                onClick={() => {
                  setIdUpd(row.id);
                  setVisivilityModalConfimation(true);
                }}
              >
                {row.active ? 'Desactivar' : 'Activar'}
              </a>
            </div>
          </div>
        </div>
      </>
    );
  };

  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 1000);

  const addRegister = () => {
    setVisivilityModal(!visivilityModal);
  };

  const handlerSendPeriodic = (id: number) => {
    setVisivilityModalConfimation(true);
    deleteZona(id)
      .then((res) => {
        const {
          data: { message },
        } = res;

        SimpleAlert(message, 3000, 'success');
        setReloadGrid(Math.random() * 40);
      })
      .catch((err) => {
        let resMessageToast: string = '';
        const {
          data: { message },
        } = err.response;
        resMessageToast = `${message}`;
        SimpleAlert(resMessageToast, 3000, 'error');
      });
  };

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <div className="row w-100 gx-2 align-items-center">
                <div className="col d-flex justify-content-end">
                  <a
                    href="#/"
                    data-kt-menu="true"
                    className="btn btn-sm btn-light-primary"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                    onClick={addRegister}
                  >
                    <KTSVG
                      path="/media/icons/duotune/arrows/arr075.svg"
                      className="svg-icon-5 svg-icon-gray-500 me-1"
                    />
                    Agregar zona
                  </a>
                </div>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <CreateModal
        show={visivilityModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityModal(!visivilityModal);
        }}
      ></CreateModal>
      <UpdateModal
        zonaId={idUpd}
        show={visivilityUpdModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityUpdModal(!visivilityUpdModal);
          setIdUpd(0);
        }}
      ></UpdateModal>
      <ConfirmModal
        title="¿Actualizar información?"
        description="Los cambios efectuados se aplicarán y actualizaran en todas las secciones relacionadas."
        show={visivilityModalConfimation}
        confirmValue={(updateData: boolean) => {
          if (updateData && idUpd > 0) {
            handlerSendPeriodic(idUpd);
          }
          setVisivilityModalConfimation(false);
          setIdUpd(0);
        }}
        onClose={() => {
          setVisivilityModalConfimation(false);
          setIdUpd(0);
        }}
      />
    </>
  );
};

export { View };
